export const CSS_TRANSITION = 'transition: 0.4s;'
export const SMALL_WIDTH = 800
export const MEDIUM_WIDTH = 1300
export const SAFFRON_RED_HEX = '#C44536'
